const baseColors = {
    black: {
        5: '#F2F2F2',
        10: '#E5E5E5',
        20: '#CCCCCC',
        30: '#B3B3B3',
        40: '#979797',
        60: '#5B5B5B',
        80: '#333333',
        100: '#000000'
    },
    blue: {
        10: '#E5F4FC',
        100: '#008EDE',
        120: '#0072B2'
    },
    electricBlue: {
        10: '#F2FBFF',
        40: '#CDF1FE',
        80: '#9BE3FD',
        100: '#2DC5FA',
        120: '#249EC8',
        140: '#1B7696',
        160: '#124F64'
    },
    green: {
        10: '#E7F9ED',
        100: '#11BE4C',
        120: '#0E983D'
    },
    oceanBlue: {
        10: '#EBE5FD',
        40: '#AEB7F9',
        70: '#4C53F1',
        80: '#5D6FF4',
        100: '#3800EB',
        120: '#2D00BC',
        140: '#1F2D91',
        160: '#16005E'
    },
    orange: {
        10: '#FEF6E9',
        100: '#F8A324',
        130: '#AE7219'
    },
    pink: {
        10: '#FDEBF3',
        40: '#FEA7CF',
        80: '#F16BA7',
        100: '#EC398A',
        120: '#B90657',
        140: '#8B0541',
        160: '#5C032C'
    },
    purple: {
        10: '#F5E8FE',
        40: '#EBD0FC',
        80: '#C273F6',
        100: '#9A16F0',
        120: '#7B12C0',
        140: '#5C0D90',
        160: '#3E0960'
    },
    red: {
        10: '#FDEDED',
        100: '#EB4C4C',
        120: '#BC3D3D'
    },
    turquoise: {
        10: '#EAFAF9',
        40: '#AAECE8',
        80: '#6BDDD6',
        100: '#2BCFC5',
        120: '#22A59E',
        140: '#1A7C76',
        160: '#11534F'
    },
    white: {
        100: '#FFFFFF'
    },
    yellow: {
        10: '#FFFEEB',
        40: '#FEFBC2',
        80: '#FCF785',
        90: '#C9FF58',
        100: '#FAF234',
        120: '#D7CE06',
        140: '#ACA502',
        160: '#837E02'
    }
};
const linearGradient = (name, angle, ...percentages)=>{
    const colors = percentages.map((percent, index)=>`var(--chakra-colors-gradient-${name}-${index}) ${percent}`);
    const args = [
        angle,
        ...colors
    ];
    return `linear-gradient(${args.join(', ')})`;
};
export const gradients = {
    ac: linearGradient('ac', '104.9deg', '27.18%', '100%'),
    ai: linearGradient('ai', '105deg', '27.18%', '100%'),
    brand: linearGradient('brand', '114.99deg', '24.14%', '105.44%'),
    ce: linearGradient('ce', '287.72deg', '0%', '87.67%'),
    cyber: linearGradient('cyber', '287.72deg', '0%', '87.67%'),
    data: linearGradient('data', '284.43deg', '0%', '96.5%'),
    de: linearGradient('de', '287.72deg', '0%', '87.67%'),
    dv: linearGradient('dv', '288deg', '0%', '87.67%'),
    hero2026: linearGradient('hero2026', '105.51deg', '4.57%', '31.89%', '69.96%', '97.72%'),
    interactive: linearGradient('interactive', '90.68deg', '-7.48%', '113.27%'),
    mk: linearGradient('mk', '288deg', '0%', '87.67%'),
    ml: linearGradient('ml', '288deg', '0%', '87.67%'),
    pm: linearGradient('pm', '287.72deg', '0%', '87.67%'),
    ux: linearGradient('ux', '104.9deg', '27.18%', '100%'),
    web: linearGradient('web', '107.05deg', '17.93%', '92.3%')
};
export default {
    ...baseColors,
    background: {
        ac: gradients.ac,
        ai: gradients.ai,
        black: baseColors.black[100],
        brand: gradients.brand,
        ce: gradients.ce,
        cloud: baseColors.blue[10],
        cyber: gradients.cyber,
        dark: baseColors.oceanBlue[160],
        data: gradients.data,
        de: gradients.de,
        dv: gradients.dv,
        hero2026: gradients.hero2026,
        interactive: gradients.interactive,
        light: baseColors.black[5],
        'light-ac': baseColors.oceanBlue[10],
        'light-ai': baseColors.turquoise[10],
        'light-ce': baseColors.pink[10],
        'light-cyber': baseColors.turquoise[10],
        'light-data': baseColors.orange[10],
        'light-de': baseColors.green[10],
        'light-dv': baseColors.pink[10],
        'light-mk': baseColors.pink[10],
        'light-ml': baseColors.oceanBlue[10],
        'light-pm': baseColors.yellow[10],
        'light-ux': baseColors.pink[10],
        'light-web': baseColors.oceanBlue[10],
        mk: gradients.mk,
        ml: gradients.ml,
        pm: gradients.pm,
        ux: gradients.ux,
        web: gradients.web,
        white: baseColors.white[100]
    },
    brand: {
        primary: baseColors.electricBlue[100],
        secondary: baseColors.oceanBlue[100]
    },
    button: {
        disabled: baseColors.black[30],
        facebook: {
            enabled: baseColors.oceanBlue[100],
            hover: baseColors.oceanBlue[140],
            pressed: baseColors.purple[160]
        },
        google: {
            enabled: baseColors.white[100],
            hover: baseColors.black[10],
            pressed: baseColors.black[20]
        },
        primary: {
            enabled: gradients.interactive,
            hover: `linear-gradient(${baseColors.oceanBlue[100]}, ${baseColors.oceanBlue[100]})`,
            pressed: baseColors.oceanBlue[140]
        },
        secondary: {
            enabled: baseColors.white[100],
            hover: baseColors.purple[100],
            pressed: baseColors.purple[140]
        },
        tertiary: {
            enabled: baseColors.purple[100],
            hover: baseColors.oceanBlue[100],
            pressed: baseColors.purple[160]
        }
    },
    fill: {
        black: baseColors.black[100],
        footer: baseColors.oceanBlue[160],
        interactive: baseColors.purple[100],
        light: baseColors.black[10],
        medium: baseColors.black[40],
        new: baseColors.pink[100],
        preFooter: baseColors.oceanBlue[140],
        primary: baseColors.electricBlue[100],
        secondary: baseColors.oceanBlue[100],
        translucid: `${baseColors.black[100]}99`,
        white: baseColors.white[100],
        yellow: baseColors.yellow[90]
    },
    gradient: {
        ac: {
            0: baseColors.oceanBlue[100],
            1: baseColors.yellow[100]
        },
        ai: {
            0: baseColors.turquoise[80],
            1: baseColors.oceanBlue[70]
        },
        brand: {
            0: '#344BF1',
            1: baseColors.electricBlue[100]
        },
        ce: {
            0: baseColors.turquoise[100],
            1: baseColors.pink[100]
        },
        cyber: {
            0: '#F9E450',
            1: baseColors.turquoise[100]
        },
        data: {
            0: baseColors.yellow[100],
            1: baseColors.pink[100]
        },
        de: {
            0: baseColors.turquoise[100],
            1: baseColors.orange[100]
        },
        dv: {
            0: baseColors.electricBlue[100],
            1: baseColors.pink[80]
        },
        hero2026: {
            0: '#7437E5',
            1: '#050A3A ',
            2: '#1F135C',
            3: '#00A4CE'
        },
        interactive: {
            0: baseColors.oceanBlue[100],
            1: baseColors.purple[100]
        },
        mk: {
            0: baseColors.pink[80],
            1: baseColors.oceanBlue[100]
        },
        ml: {
            0: '#2EC6FB',
            1: '#D6A2F9'
        },
        pm: {
            0: baseColors.yellow[100],
            1: baseColors.purple[120]
        },
        ux: {
            0: baseColors.pink[100],
            1: baseColors.purple[100]
        },
        web: {
            0: baseColors.purple[100],
            1: baseColors.electricBlue[100]
        }
    },
    icon: {
        dark: baseColors.black[100],
        error: baseColors.red[100],
        info: baseColors.blue[100],
        new: baseColors.purple[100],
        primary: baseColors.electricBlue[100],
        secondary: baseColors.oceanBlue[100],
        success: baseColors.green[100],
        warning: baseColors.orange[100]
    },
    link: {
        link: baseColors.purple[100],
        hover: baseColors.oceanBlue[100],
        pressed: baseColors.purple[140],
        disabled: baseColors.black[30],
        inverse: baseColors.white[100]
    },
    stroke: {
        dark: baseColors.black[100],
        error: baseColors.red[100],
        info: baseColors.blue[100],
        interactive: baseColors.purple[100],
        light: baseColors.black[30],
        medium: baseColors.black[40],
        success: baseColors.green[100],
        warning: baseColors.orange[100],
        white: baseColors.white[100]
    },
    support: {
        error: {
            icon: baseColors.red[100],
            background: baseColors.red[10],
            text: baseColors.red[120]
        },
        info: {
            icon: baseColors.blue[100],
            background: baseColors.blue[10],
            text: baseColors.blue[120]
        },
        success: {
            icon: baseColors.green[100],
            background: baseColors.green[10],
            text: baseColors.green[120]
        },
        warning: {
            icon: baseColors.orange[100],
            background: baseColors.orange[10],
            text: baseColors.orange[130]
        }
    },
    text: {
        inverse: baseColors.white[100],
        primary: baseColors.black[100],
        secondary: baseColors.black[60],
        tertiary: baseColors.black[40]
    }
};

//# sourceMappingURL=color.js.map